import TcMap from 'components/UI/Map/TcMap';
import useQuery from 'global/helperFunctions/useQuery';
import { FC, useMemo } from 'react';
import { FeatureGroup } from 'react-leaflet';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import TcMapSearchResults from '../actions/TcMapSearchResults';
import MapLatLng from '../MapLatLng';
import TcMapViewFeatures from './TcMapViewFeatures';

interface IMappViewerWrapper {
  setSelectedLocation?: (_latlng: { lat: number; lng: number }) => void;
  selectedLocation?: { lat: number; lng: number };
  handleUrl: (_zoomLevel: number, _center: Record<'lat' | 'lng', any>) => void;
}

const TcMapViewerWrapper: FC<IMappViewerWrapper> = ({ handleUrl, selectedLocation, setSelectedLocation }) => {
  //states
  const { map } = useSelector((state: RootState) => state.map);

  const { query, search } = useQuery();

  const initialCenter: [number, number] | undefined = useMemo(() => {
    if (query.x && query.y) {
      return [query.y, query.x];
    }
    return undefined;
  }, [search]);

  return (
    <>
      <TcMap zoomLevel={query.z} customHeight='h-80' initialCenter={initialCenter}>
        <FeatureGroup>
          <TcMapSearchResults setSelectedLocation={setSelectedLocation} selectedLocation={selectedLocation} />
          <TcMapViewFeatures handleUrl={handleUrl} />
        </FeatureGroup>
      </TcMap>
      <MapLatLng map={map} />
    </>
  );
};

export default TcMapViewerWrapper;
